export default {
  namespaced: true,
  getters: {
    elements: (state, getters, rootState, rootGetters) => (element, parentModule) => {
      let columns = rootGetters['layoutRowModule/elements'](element, parentModule).columns
      return Object.prototype.hasOwnProperty.call(element, 'column') ? columns[element.column] : columns
    },
    index: (state, getters) => (element, id, parentModule) =>  getters.elements(element, parentModule).findIndex(column => column.id == id),
    id: (state, getters) => (element, id = 'id', parentModule) => getters.elements(element, parentModule)[id],
    name: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).name,
    classes: (state, getters) => (element, classes = 'classes', parentModule) => getters.elements(element, parentModule)[classes],
    styles: (state, getters) => (element, styles = 'styles', parentModule) => getters.elements(element, parentModule)[styles],
    assets: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).assets,
    background: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).background,
    properties: (state, getters) => (element, parentModule) => getters.elements(element, parentModule).properties,
  },

  actions: {
        updateOrder({commit}, payload) {
            payload = {...payload, module: 'layoutColumnModule'}
            commit('actionsModule/updateElementsOrder', payload, {root: true})
        },
        addToArray({commit}, payload) {
            payload = {...payload, module: 'layoutColumnModule'}
            commit('actionsModule/addToArray', payload, {root: true})
        },
        removeFromArray({commit}, payload) {
            payload = {...payload, module: 'layoutColumnModule'}
            commit('actionsModule/removeFromArray', payload, {root: true})
        },
        addToObject({commit}, payload) {
            payload = {...payload, module: 'layoutColumnModule'}
            commit('actionsModule/addToObject', payload, {root: true})
        },
  }
}